export default __webpack_public_path__ + "static/media/SourceHanSansCN-Bold.5b6413e1.otf";